import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root', // This makes the service available app-wide
})
export class GlobalEventService {
  private eventSubject = new Subject<any>(); // Subject to broadcast events
  event$ = this.eventSubject.asObservable(); // Observable to subscribe to the events

  /**
   * Broadcast an event globally.
   * @param eventName The name of the event to broadcast.
   * @param payload Any data to pass with the event.
   */
  broadcast(eventName: string, payload?: any): void {
    this.eventSubject.next({ name: eventName, data: payload });
  }
}